import { render, staticRenderFns } from "./CImg.vue?vue&type=template&id=40261e78&scoped=true&"
import script from "./CImg.vue?vue&type=script&lang=js&"
export * from "./CImg.vue?vue&type=script&lang=js&"
import style0 from "./CImg.vue?vue&type=style&index=0&id=40261e78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40261e78",
  null
  
)

export default component.exports